import { useEffect, useRef } from 'react';

/**
 * Custom hook for debounced effects
 */
export function useDebouncedEffect(
    effect: () => void,
    deps: Array<any>,
    delay: number,
    disableDebounce: boolean = false,
) {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (disableDebounce) return;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            effect();
        }, delay);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps, disableDebounce]);
}

/**
 * Custom hook for formatting dates in Norwegian locale
 */
export const useFormattedDate = (date?: string) => {
    if (!date) return;

    return new Date(date)?.toLocaleDateString('nb-NO', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
};
